import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { grey } from '@material-ui/core/colors';
import { Grid, Avatar, Typography } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import PersonIcon from '@material-ui/icons/Person';
import logo from '../images/lasa_logo.png';
import consts from '../main/consts';

const styles = theme => ({
  root: {
    display: 'flex',
    backgroundColor: grey[200],
    height: '100vh'
  },
  avatarSmall: {
    color: '#FFF',
    backgroundColor: grey[300],
    width: 70,
    height: 70
  },
  iconSmall: {
    color: grey[500],
    width: 45,
    height: 45
  },
  icon: {
    color: grey[600],
    width: 100,
    height: 100,
    marginLeft: -16,
    marginRight: -16
  },
  logo: {
    color: '#FFF',
    backgroundColor: '#F80032',
    width: 70,
    height: 70,
    padding: 18
  },
  separate: {
    width: 20,
    height: 0,
    margin: 5,
    borderBottom: `2px dashed ${grey[500]}`
  },

  text: {
    minWidth: 220,
    textAlign: 'center',
    marginTop: 20,
  }

});
class Unauthorized extends React.Component {

  render() {

    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <CssBaseline />
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid>
              <Avatar className={classes.avatarSmall} >
                <PersonIcon className={classes.iconSmall} />
              </Avatar>
            </Grid>
            <Grid>
              <div className={classes.separate}></div>
            </Grid>
            <Grid>
              <LockIcon className={classes.icon} />
            </Grid>
            <Grid>
              <div className={classes.separate}></div>
            </Grid>
            <Grid>
              <Avatar className={classes.logo} src={logo}></Avatar>
            </Grid>
          </Grid>
          <Grid className={classes.text}>
            <Typography variant="h5">Acesso Negado</Typography>
            <Typography variant="body2">Você precisa se autenticar.</Typography>
            <Typography variant="body2">Clique <a href={`${consts.CONTEXT}/home`}>aqui</a> para logar</Typography>
          </Grid>
        </Grid>
      </div>
    );
  }

}
export default compose(withStyles(styles))(Unauthorized)
